import { P2GButton } from '@parcel2go/core-ui';

import { ProviderGroupState } from '../../../../lib/helpers/SmartSendBulkActionApplier';
import TermsRow from './TermsRow';
import { LinkApiModel } from '~/lib/api/smartsend/types';
import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';

interface props {
  bookAll: () => void;
  close: () => void;
  states: ProviderGroupState[];
  groupCount: number;
  disabled: boolean;
  isXs: boolean;
  termsLinks: LinkApiModel[];
}

const BookAll: React.FC<props> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const allBooked = props.states.filter((x) => x === 'BOOKED').length === props.states.length;

  return (
    <TermsRow
      isXs={props.isXs}
      termsLink={props.termsLinks}
      button={
        allBooked ? (
          <P2GButton onClick={props.close}>{t('CLOSE_BUTTON', { defaultValue: 'Close' })}</P2GButton>
        ) : (
          <P2GButton disabled={!props.states.includes('IDLE') || props.disabled} onClick={props.bookAll}>
            {props.groupCount > 1
              ? t('BOOK_ALL_ORDERS_BUTTON', { defaultValue: 'Book All {{count}} Orders', count: props.groupCount })
              : t('BOOK_ALL_BUTTON', { defaultValue: 'Book All' })}
          </P2GButton>
        )
      }
    />
  );
};
export default BookAll;
